export const BASE_URL =
  window.location.host.indexOf("localhost") < 0
    ? window.location.protocol + "//" + window.location.host
    : "https://donate.efraincy.life";

export const LIST_URL = "https://story.heartslink.it.com";

export default {
  GETDONTIONLIST: "/api/public_projects.php", //获取所有捐款列表
  GETDONTIONDETAIL: "/api/public_project.php", //获取捐款详情
  LOGIN: "/api/Denglu/login",
  LOGINOUT: "/api/Denglu/logout",
  ADDSTORY: "/api/Tiezi/setTiezi",
  GETSTORYLIST: "/api/Tiezi/getTiezilist",
  UPLOAD: "/api/common/upload",
  UPGRADE: "/api/Tiezi/getTiezi",
  DELETE: "/api/Tiezi/delTiezi",
  GETREVIEWSLIST: "/api/Pinglun/getPinglunlisttiezi",
  ADDREVIEW: "/api/Pinglun/setPinglun",
  PIXEL: "https://www.hugfb.com/api/Urlrelation/getUrlrelationUrl",
  FACEBOOK: "/api/facebook/EventsAll",
  PAYMENT: "/api/index/index",
  PAYMENT1: "/api/index/index1",
  PAYMENT2: "/api/index/index2",
  GETPK: "/api/index/get_pk",
  GET_URL: "/api/index/get_url",
  SUCCESS: "/api/index/customstatus",
  GETTIEZI: "/api/Tiezi/getTiezilist",
  GETPINGLUN: "/api/Pinglun/getPinglunlisttiezi",
  SENDMESSAGE: "/api/index/send_kf_2",
  ADDRESS: "/api/index/address",
  GET_ORDER: "/api/index/getOrderInfoByOrderNo",
  GET_ORDER_LIST: "/api/index/get_order_list",
  SEND_EMAIL_TO_CLIENT: "https://www.hsmail.vip/api/External/SingleEmailSend",
};
